import React from 'react';
import { ButtonOption } from './ButtonOption';

export const ButtonOptionPrimary = (props) => {
  return <ButtonOption variant="primary" {...props} />;
};

ButtonOptionPrimary.propTypes = ButtonOption.propTypes;
